export const ORDER_LIST_INITIAL_SIZE = 3
export const MONTHLY_ORDER_LIST_INITIAL_SIZE = 6
export const TODO_ORDER_LIST_INITIAL_SIZE = 100
export const LOAD_MORE_ORDERS_PAGE_SIZE = 10

export const MONTHLY_INVOICE_LIST_INITIAL_SIZE = 3
export const LOAD_MORE_MONTHLY_INVOICES_PAGE_SIZE = 10

export const FILTER_NAME = {
  ALL: 'all',
  TO_DO: 'toDo',
}

export const SUBSCRIPTION_TYPES = {
  MERCHANT_MONTHLY: 'MERCHANT_MONTHLY',
}

export const OPERATIONS = {
  PURCHASE_POWER: 'PURCHASE_POWER',
  MANAGE_MONTHLY: 'MANAGE_MONTHLY',
  MANAGE_CARD: 'MANAGE_CARD',
}

export const INVOICE_OPERATIONS = {
  PAY: 'PAY',
  REPORT_RETURN: 'REPORT_RETURN',
}

export const OPERATION_RESULTS = {
  ERROR: 'ERROR',
  NO_STATE_CHANGE: 'NO_STATE_CHANGE',
  STATE_CHANGE: 'STATE_CHANGE',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
}

export const PAYABLE_MONTHLY_INVOICE_STATUSES = ['STATEMENT_GENERATED', 'OVERDUE']

export const ORDER_LINE_TYPES = {
  PHYSICAL: 'physical',
  DISCOUNT: 'discount',
  SHIPPING_FEE: 'shipping_fee',
  SALES_TAX: 'sales_tax',
  STORE_CREDIT: 'store_credit',
  GIFT_CARD: 'gift_card',
  DIGITAL: 'digital',
  SURCHARGE: 'surcharge',
}
